export default function CartIcon({ ...rest }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='41'
      height='40'
      viewBox='0 0 41 40'
      fill='none'
      {...rest}
    >
      <rect width='41' height='40' rx='5' fill='currentColor' />
      <path
        d='M16.5455 28.182C16.9973 28.182 17.3637 27.8157 17.3637 27.3638C17.3637 26.9119 16.9973 26.5456 16.5455 26.5456C16.0936 26.5456 15.7273 26.9119 15.7273 27.3638C15.7273 27.8157 16.0936 28.182 16.5455 28.182Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.5454 28.182C25.9973 28.182 26.3636 27.8157 26.3636 27.3638C26.3636 26.9119 25.9973 26.5456 25.5454 26.5456C25.0936 26.5456 24.7273 26.9119 24.7273 27.3638C24.7273 27.8157 25.0936 28.182 25.5454 28.182Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 11H13.2727L15.4655 21.9555C15.5403 22.3321 15.7452 22.6705 16.0444 22.9113C16.3435 23.1522 16.7178 23.2801 17.1018 23.2727H25.0545C25.4385 23.2801 25.8129 23.1522 26.112 22.9113C26.4112 22.6705 26.6161 22.3321 26.6909 21.9555L28 15.0909H14.0909'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
